

















































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import listMixins from '../../../mixins/list'
import { columns } from './config'
import PartnerApi from '@/api/partner'

@Component({})
export default class App extends Mixins(listMixins) {
	@Prop()
	private visible!: boolean

	@Prop()
	private areas!: any

	@Prop()
	private partnerId!: any

	@Prop()
	private selectedVisitor!: any

	private confirmLoading: boolean = false

	private columns: object = columns

	private data: any = []

	private get formatAreas() {
		return (
			this.areas &&
			this.areas.map((item: any) => {
				if (item.slice(-2) !== '00') {
					return {
						areaCode: item,
					}
				} else if (item.slice(2, 4) !== '00') {
					return {
						cityCode: item,
					}
				} else {
					return {
						provinceCode: item,
					}
				}
			})
		)
	}

	public async getList() {
		const id = this.partnerId || this.$store.state.user.userInfo.companyId
		if (id && id !== 1) {
			const res = await PartnerApi.getVisitorByArea({
				companyId: id,
				keyworld: this.searchForm.getFieldValue('keyworld'),
				areasDTOs: this.formatAreas,
			})
			this.data = res.data
		}
	}

	@Watch('visible')
	protected async onVisible() {
		if (this.visible) {
			if (this.selectedVisitor.length) {
				this.selectedRowKeys = this.selectedVisitor.map((item: any) => {
					return item.id
				})
			}
			this.getList()
		}
	}

	private onChooseVisitorOk() {
		this.$emit('update:visible', false)
		this.$emit('ok', this.selected)
	}

	private onCancel() {
		this.$emit('update:visible', false)
	}
}
